module.exports = __webpack_public_path__ + "static/media/Manual.6b136bb4.pdf";